import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  '@global': {
    '#overlay-dialog-description': {
      padding: '8px 46px'
    },
    '#overlay-dialog-description > div > p': {
      lineHeight: '1.6rem'
    },
    '#edi-overlay-text': {
      color: '#53759B'
    }
  },
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2)
    },
    position: 'absolute',
    marginTop: '40px',
    width: '100%'
  }
}));
